import React from "react";
import Average from "./Average";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Box, Divider, Typography } from "@mui/material";

const AverageList = ({
  isLoading,
  averages,
  header,
  filterOptions,
  filterValue,
  onFilterChange,
  menuWidth
}) => {
  return (
    <Box display="flex" flexDirection="column" flex={1}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">{header}</Typography>
        <Box display="flex" justifyContent="flex-end" width={menuWidth}>
          {filterOptions && !isLoading && (
            <Select
              name="averagesFilter"
              value={filterValue}
              onChange={e => onFilterChange(e.target.value)}
              displayEmpty
              autoWidth
              SelectDisplayProps={{ sx: { padding: "0 32px 0 5px!important" } }}
            >
              {filterOptions.map(option => (
                <MenuItem value={option.value} key={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          )}
        </Box>
      </Box>
      <Divider sx={{ mt: 1, mb: 1.5 }} />
      {averages.map(average => (
        <Average
          key={average.label}
          label={average.label}
          average={average.value}
          isLoading={isLoading}
        />
      ))}
    </Box>
  );
};

export default AverageList;
